// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as URLUtils$Showside from "./URLUtils.bs.js";
function isCloudflareStreamImg(src) {
  return src.includes(".cloudflarestream.com");
}
function getValidSize(w, h, url) {
  var w$1 = Caml.int_min(2000, 10 > w ? 10 : w);
  var h$1 = Caml.int_min(2000, 10 > h ? 10 : h);
  var _w = (w$1 > h$1 ? w$1 : h$1) === w$1 ? String(w$1) : undefined;
  var _h = (w$1 > h$1 ? w$1 : h$1) === h$1 ? String(h$1) : undefined;
  var url$1 = URLUtils$Showside.maybeMakeUrl(url);
  if (url$1 === undefined) {
    return [_w, _h];
  }
  var searchParams = Caml_option.valFromOption(url$1).searchParams;
  var width = searchParams.get("width");
  var width$1 = width == null ? undefined : Caml_option.some(width);
  var height = searchParams.get("height");
  var height$1 = height == null ? undefined : Caml_option.some(height);
  if (!(width == null) || !(height == null)) {
    return [width$1, height$1];
  } else {
    return [_w, _h];
  }
}
function removeQueryParams(url) {
  return Belt_Option.getWithDefault(Belt_Array.get(url.split("?"), 0), url);
}
function makeUrl(wOpt, hOpt, wrapper, url) {
  var w = wOpt !== undefined ? wOpt : 0;
  var h = hOpt !== undefined ? hOpt : 0;
  var match = getValidSize(w, h, url);
  var _h = match[1];
  var _w = match[0];
  var queryStr = _w !== undefined ? "?width=" + _w : _h !== undefined ? "?height=" + _h : "";
  var urlWithoutQueryStr = removeQueryParams(url);
  return Curry._4(wrapper, urlWithoutQueryStr + queryStr, w, h, undefined);
}
function makeCoverUrl(wOpt, hOpt, wrapper, url) {
  var w = wOpt !== undefined ? wOpt : 0;
  var h = hOpt !== undefined ? hOpt : 0;
  var match = getValidSize(w, h, url);
  var _h = match[1];
  var _w = match[0];
  var queryStr = _w !== undefined ? "?width=" + _w + "&fit=crop" : _h !== undefined ? "?height=" + _h + "&fit=crop" : "?fit=crop";
  var urlWithoutQueryStr = removeQueryParams(url);
  return Curry._4(wrapper, urlWithoutQueryStr + queryStr, w, h, undefined);
}
var Thumbnail = {
  getValidSize: getValidSize,
  removeQueryParams: removeQueryParams,
  makeUrl: makeUrl,
  makeCoverUrl: makeCoverUrl
};
export { isCloudflareStreamImg, Thumbnail };
/* No side effect */